import { action, computed, makeObservable, observable } from 'mobx';

import { FAST_MODE_ENABLED } from '@/configs/env';

const STORAGE_KEY = 'llm_fast_mode';

function readStoredValue(): boolean {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);

    return stored === null ? true : stored === 'true';
  } catch {
    return true;
  }
}

export class FastModeStore {
  private _enabled = readStoredValue();

  constructor() {
    makeObservable<FastModeStore, '_enabled'>(this, {
      _enabled: observable,
      enabled: computed,
      toggle: action.bound,
    });
  }

  /** Всегда false, если режим отключён флагом, даже при `true` в localStorage */
  get enabled(): boolean {
    return FAST_MODE_ENABLED && this._enabled;
  }

  toggle(): void {
    if (!FAST_MODE_ENABLED) {
      return;
    }

    this._enabled = !this._enabled;

    try {
      window.localStorage.setItem(STORAGE_KEY, String(this._enabled));
    } catch {
      /* no-op */
    }
  }
}
